<div class="container">
  <div class="homepage-section-header">{{ PRODUCT_NAME }}' PARTNERS</div>
  <app-carousel-main
    [numItems]="carouselConfig.numItems"
    [itemGap]="carouselConfig.itemGap"
    [showArrowBackground]="false"
    [alwaysShowArrows]="true"
    [arrowColorDark]="true"
    [maintainRatio]="0"
    [itemOffset]="carouselConfig.itemOffset"
    *ngIf="partners"
  >
    <ng-container *ngFor="let partner of partners">
      <div
        class="partner-wrapper"
        *appCarouselItem
      >
        <img
          class="partner"
          src="{{ partner.logoUrl }}"
          [matTooltip]="partner.partnerName"
          matTooltipShowDelay="500"
          imgErrLog
        />
      </div>
    </ng-container>
  </app-carousel-main>

  <div
    class="error"
    *ngIf="error"
  >
    {{ error }}
  </div>
  <div
    class="spinner"
    *ngIf="loading"
  >
    <merri-loading-spinner [loading]="loading"></merri-loading-spinner>
  </div>
</div>
